import { render, staticRenderFns } from "./baseMapChsPoint.vue?vue&type=template&id=4caec668"
import script from "./baseMapChsPoint.vue?vue&type=script&lang=js"
export * from "./baseMapChsPoint.vue?vue&type=script&lang=js"
import style0 from "./baseMapChsPoint.vue?vue&type=style&index=0&id=4caec668&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports